<template>
  <div class="jumpApp-btn" @click="openTuer">
    <slot name="btnName"></slot>
  </div>
</template>

<script>
  import mobileType from '@/utils/mobileType';
  import browserType from '@/utils/browserType';
  import wx from 'weixin-js-sdk';

  export default {
    props: ['params', 'mark', 'userStatus', 'h5Jump', 'jumpUrl', 'toast'],
    data() {
      return {
        downloadUrl: '',
        schemeUrlIndexCk: 'wsjc://app/home?serviceType=900&roleType=1',
        schemeUrlIndexCZ: 'wsjc://app/home?serviceType=900&roleType=2',
        schemeUrlCZRZ: 'wsjc://900/dAuth',
        jumpUrls: '',
        // schemeUrlCXLDY: '',
      };
    },
    created() {
      if (mobileType.isIOS()) {
        this.downloadUrl = 'https://itunes.apple.com/cn/app/万顺叫车/id1180877789?mt=8';
      }
      if (mobileType.isAndroid()) {
        this.downloadUrl = 'https://android.myapp.com/myapp/detail.htm?apkName=com.wsecar.wsjc';
      }
    },
    watch: {
      jumpUrl: {
        handler: function (val) {
          this.jumpUrls = val;
        },
        deep: true
      }
    },
    mounted() {
      let env;
      if (process.env.VUE_APP_CURRENTMODE == 'dev') {
        env = '-' + process.env.VUE_APP_CURRENTMODE;
      } else if (process.env.VUE_APP_CURRENTMODE == 'dev1') {
        env = '-dev';
      } else if (process.env.VUE_APP_CURRENTMODE == 'prod') {
        env = '';
      } else {
        env = '-' + process.env.VUE_APP_CURRENTMODE;
      }
      if (browserType.isWeixin()) {
        // alert('微信不支持');
      } else {
        // this.openTuer();
      }
      this.jumpUrls = this.jumpUrl;
    },
    methods: {
      // 点击打开app
      openTuer() {
        if (this.mark == '代驾乘客首页') {
          if (this.params.platform == 1 || this.params.platform == 2) {
            this.$options.methods.jumpApp(this.schemeUrlIndexCk);
          } else if (this.params.platform == 3) {
            wx.miniProgram.reLaunch({
              url: '/pages/index/index'
            });
          } else {
            this.$options.methods.jumpApp(this.schemeUrlIndexCk);
            this.noApp();
          }
        } else if (this.mark == '代驾车主首页') {
          if (this.params.platform == 1 || this.params.platform == 2) {
            this.$options.methods.jumpApp(this.schemeUrlIndexCk);
          } else if (this.params.platform == 3) {
            wx.miniProgram.reLaunch({
              url: '/pages/index/index?type=1'
            });
          } else {
            this.$options.methods.jumpApp(this.schemeUrlIndexCk);
            this.noApp();
          }
        } else if (this.mark == '短信落地页') {

          if (browserType.isWeixin()) {
            window.location.href = this.downloadUrl;
          } else {
            //ios的scheme协议
            // window.location.href = this.jumpUrls;
            // setTimeout(function () {
            //   let hidden = window.document.hidden || window.document.mozHidden || window.document.msHidden || window.document.webkitHidden;
            //   if (typeof hidden == 'undefined' || hidden == false) {
            //     //App store下载地址
            //     window.location.href = this.downloadUrl;
            //   }
            // }, 2000);

            this.$options.methods.jumpApp(this.jumpUrls);
            this.noApp();
          }
        } else if (this.mark == '车主认证') {
          if (this.params.platform == 1 || this.params.platform == 2) {
            if (JSON.stringify(this.userStatus) != '{}') {
              if (this.userStatus.identityAuditType == 2) {
                if (this.toast) {
                  this.$toast(this.toast);
                } else {
                  this.$options.methods.jumpApp(this.schemeUrlIndexCk);
                }
              } else {
                this.$options.methods.jumpApp(this.schemeUrlCZRZ);
              }
            } else {
              this.$options.methods.jumpApp(this.schemeUrlCZRZ);
            }
          } else if (this.params.platform == 3) {
            wx.miniProgram.reLaunch({
              url: '/certification/pages/requirements/requirements?activeid=' + this.params.activityId
            });
          } else {
            if (this.h5Jump == 'h5') {
              this.$router.push({
                path: '/home/ownerCertificationNew',
                query: {}
              });
            } else {
              this.$options.methods.jumpApp(this.schemeUrlCZRZ);
              this.noApp();
            }
          }
        }
        // if (mobileType.isIOS()) {
        //   this.$options.methods.jumpApp(this.schemeUrl);
        //   // this.$options.methods.jumpApp('taobao://');
        //   // this.$options.methods.jumpApp('taobaotravel://');
        //   // this.$options.methods.noApp();
        //   this.noApp();
        // } else {
        //   this.$options.methods.jumpApp(this.schemeUrl);
        //   this.noApp();
        // }
      },
      // 跳转打开app
      jumpApp(t) {
        try {
          let e = navigator.userAgent.toLowerCase(),
            n = e.match(/cpu iphone os (.*?) like mac os/);
          if (
            ((n = null !== n ? n[1].replace(/_/g, '.') : 0), parseInt(n) >= 9)
          ) {
            window.location.href = t;
          } else {
            const r = document.createElement('iframe');
            (r.src = t), (r.style.display = 'none'), document.body.appendChild(r);
          }
        } catch (e) {
          window.location.href = t;
        }
      },
      // 无响应或者没安装跳转下载
      noApp() {
        const t = Date.now(),
          r = this.downloadUrl;
        this.timer = setTimeout(function () {
          return Date.now() - t > 2200
            ? (clearTimeout(this.timer), !1)
            : !document.webkitHidden &&
            !document.hidden &&
            void (location.href = r);
        }, 2000);
      },
    },
  };
</script>
<style lang="less" scoped>
</style>
